<p class="gl-status-error" *ngIf="showMessage" i18n>
  В форме есть ошибки, проверьте данные и попробуйте сохранить снова
</p>
